import React, { useState } from 'react';
import { apiClient } from '../../lib/apiClient.js';

export default function ChangePasswordSection() {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [status, setStatus] = useState(null);
  const [msg, setMsg] = useState('');
  const [saving, setSaving] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (next !== confirm) { setStatus('error'); setMsg('New passwords do not match.'); return; }
    if (next.length < 8) { setStatus('error'); setMsg('Password must be at least 8 characters.'); return; }
    setSaving(true); setStatus(null);
    try {
      await apiClient.changePassword(current, next);
      setStatus('success'); setMsg('Password updated successfully.');
      setCurrent(''); setNext(''); setConfirm('');
    } catch (err) {
      setStatus('error'); setMsg(err.message || 'Failed to update password.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="card overflow-hidden">
      <div className="px-5 py-3.5 border-b border-border bg-bg-s2">
        <h2 className="text-[13px] font-semibold text-text">Change Password</h2>
      </div>
      <form onSubmit={handleSubmit} className="p-5 space-y-3 max-w-sm">
        {['Current password', 'New password', 'Confirm new password'].map((label, i) => {
          const vals = [current, next, confirm];
          const setters = [setCurrent, setNext, setConfirm];
          return (
            <div key={label}>
              <label className="block text-[10px] font-mono uppercase tracking-widest text-text-faint mb-1">{label}</label>
              <input
                type="password"
                value={vals[i]}
                onChange={(e) => setters[i](e.target.value)}
                required
                className="w-full px-3 py-2 rounded-lg border border-border bg-bg text-sm text-text focus:outline-none focus:ring-2 focus:ring-accent/30"
              />
            </div>
          );
        })}
        {status && (
          <p className={`text-xs ${status === 'success' ? 'text-success' : 'text-danger'}`}>{msg}</p>
        )}
        <button
          type="submit"
          disabled={saving}
          className="px-4 py-2 rounded-lg bg-accent text-white text-sm font-medium hover:bg-accent-dark transition-colors disabled:opacity-50"
        >
          {saving ? 'Updating…' : 'Update Password'}
        </button>
      </form>
    </div>
  );
}
